<template>
  <div class="mt-2 md:mt-3">
    <v-select
      :clearable="clearable"
      class="v-select"
      :value="value"
      label="label"
      :reduce="options => options.value"
      @input="setSelected"
      :loading="loading"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="options"
      :searchable="searchable"
    >
      <template #header>
        <label class="block mb-1 font-bold">{{ label }}</label>
      </template>
      <template #option="{ label, images }" v-if="hasImages">
        <div class="flex items-center">
          <div class="w-4 mr-2">
            <img
              v-if="typeof images === 'string'"
              :src="base64Image(images)"
              :alt="label + ' logo'"
            />
          </div>
          <div>{{ label }}</div>
        </div>
      </template>
      <template #selected-option="{ label }">
        <div class="max-w-full truncate">{{ label }}</div>
      </template>
      <div slot="no-options">{{ $t("sidebar.notFound") }}</div>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    label: String,
    placeholder: String,
    disabled: Boolean,
    loading: Boolean,
    value: String,
    target: String,
    clearable: Boolean,
    hasImages: Boolean,
    searchable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    vSelect
  },
  methods: {
    setSelected (value) {
      this.$emit('selected', { target: this.target, value });
    },
    base64Image (base64String) {
      return `data:image/png;base64, ${base64String}`;
    }
  }
};
</script>

<style lang="postcss">
:root {
  --vs-dropdown-option--active-bg: theme("colors.darkblue");
  --vs-controls-color: theme("colors.darkblue");
  --vs-search-input-bg: theme("colors.gray.100");
  --vs-dropdown-option-padding: 4px 10px;

  @screen md {
    --vs-dropdown-option-padding: 4px 15px 4px 10px;
  }
}
.v-select .vs__search::placeholder,
.v-select .vs__dropdown-toggle,
.v-select .vs__dropdown-menu {
  @apply rounded-sm border-gray-400;
}
.v-select .vs__selected {
  @apply text-gray-700 max-w-full;
}
.v-select .vs__selected-options {
  max-width: calc(100% - 25px);
  flex-wrap: nowrap;
}
@screen md {
  .vs__dropdown-menu {
    width: auto;
    min-width: 100%;
  }
}

.v-select.vs--disabled {
  opacity: 0.5;
  filter: grayscale(100%);
}
</style>
